import React, { useState, useEffect } from "react";
import Container from "../../../components/layout/Container/Container";
import {
  getHarvestDetails,
  getHarvestApplications,
} from "../../../api/apimethods";
import HarvestDetailsGrid from "./HarvestDetailsGrid";
import HarvestApplicationsGrid from "./HarvestApplicationsGrid";
import { IHarvestApplicationResponseModel } from "../../../typings/models/HarvestApplicationResponseModel";
import { useLocation } from "react-router-dom";
import { AppContext, defaultAppContextData } from "../../../services/appData";
import { useAuthService, useContextService } from "../../../services";

const HarvestDetailsDashboard: React.FC = () => {
  const { getContextValueFromStorage } = useContextService();
  const [contextData] = useState(() =>
    getContextValueFromStorage(defaultAppContextData)
  );
  const user = contextData.user;

  const [data, setData] = useState<IHarvestApplicationResponseModel[]>([]);
  const [harvestDetails, setHarvestDetails] = useState<
    IHarvestApplicationResponseModel[]
  >([]);
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();
  const tab = location.state?.activeTab;
  const regType = location.state;
  // Fetch data from API on component mount
  useEffect(() => {
    const fetchData = async () => {
      try {
        let idNumber;
        if(user.uen){
          idNumber = user.uen;
        }
        else if(user.idNo){
          idNumber = user.idNo;
        }
        const response = await getHarvestApplications(idNumber);
        setData(response.data);
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
        console.error("Error fetching harvest applications:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        let idNumber;
        if(user.uen){
          idNumber = user.uen;
        }
        else if(user.idNo){
          idNumber = user.idNo;
        }
        const response = await getHarvestDetails(idNumber);
        setHarvestDetails(response.data);
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
        console.error("Error fetching harvest details:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <>
      {/* <Header /> */}
      <Container>
        {/* <Banner name="DragonFish all schedule tasks" uiClass="banner-bg" /> */}
        {/* <h3>My all tasks</h3> */}
        <div>
          <h1 className="csp-color-02763A">Harvest Details</h1>
          <HarvestDetailsGrid data={harvestDetails} isLoading={isLoading} />
        </div>

        <div>
          <h1 className="csp-color-02763A">Harvest Details Applications</h1>
          <HarvestApplicationsGrid data={data} isLoading={isLoading} />
        </div>
      </Container>
    </>
  );
};

export default HarvestDetailsDashboard;
